<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title">DADOS COMPLEMENTARES</h3>
  </div>
  <div class="modal-body">
    <form class="forms" #f="ngForm" >
      <div class="row">
        <div class="form-group">
          <span class="icon id-number"></span>
          <div class="inputs">
              <label for="user-id">Identificação</label>
              <select class="form-control" id="user-id" name="tipoDocumentoCliente" [(ngModel)]="cliente.tipoDocumento" appShowErrorMessages required requiredMessage="Tipo de Documento do Cliente é obrigatório">
                  <option value="undefined" selected hidden>Selecione o tipo de documento...</option>
                  <option value="CARTEIRA_DE_CLASSE">Carteira de Classe</option>
                  <option value="CNH">Carteira de Habilitação</option>
                  <option value="CTPS">Carteira Profissional</option>
                  <option value="RG">Registro Geral - RG</option>
              </select>
          </div>
        </div>

        <!-- DADOS DOCUMENTOS -->
        <div class="form-group">
          <span class="icon "></span>
          <div class="inputs">
              <label for="user-id">Número</label>
              <input type="text"
                  maxlength="20"
                  class="form-control"
                  appOnlyNumberRestrictive
                  name="numeroDocumentoCliente"
                  [(ngModel)]="cliente.tipoDocumentoNumero"
                  placeholder=""
                  appShowErrorMessages
                  requiredMessage="Numero do Documento do Cliente é obrigatório"
                  required />
          </div>
        </div>

        <div class="form-group">
          <span class="icon "></span>
          <div class="inputs">
              <label for="user-id">Órgão Expedidor</label>
              <input  maxlength="20" type="text" class="form-control" name="orgaoDocumentoCliente" [(ngModel)]="cliente.tipoDocumentoEmissor" placeholder="" appShowErrorMessages required [charOnly]="true" uppercase />
          </div>
        </div>

        <div class="form-group">
          <span class="icon "></span>
          <div class="inputs">
              <label for="emiss-doc">Data de Emissão</label>
              <input type="text"
                    [(ngModel)]="cliente.tipoDocumentoDataEmissao"
                    class="form-control"
                    id="emiss-doc"
                    placeholder="Digite apenas números"

                    appDataEmissaoValidator
                    [dataNascimento]="cliente.dtNascimento"

                    appShowErrorMessages
                    mask-number [mask]="'99/99/9999'"
                    name="emissaoDocumentoCliente"
                    required />
          </div>
        </div>

        <div class="form-group">
          <span class="icon mother"></span>
          <div class="inputs">
              <label for="nomeMaeClienteSel">Nome da Mãe</label>
              <input type="text"
                    maxlength="60"
                    class="form-control"
                    id="user-mon-other-name"
                    placeholder="Digite o nome completo"
                    uppercase
                    [charOnly]="true"
                    maxlength="60"
                    uppercase
                    name="nomeMaeClienteText"
                    [(ngModel)]="cliente.nomeMae"
                    #nomeMaeClienteInput="ngModel"
                    appShowErrorMessages
                    requiredMessage="Nome da Mãe é obrigatório"
                    [required]="true" />
          </div>
        </div>

        <div class="form-group">
          <span class="icon father"></span>
          <div class="inputs">
              <label for="user-father-name">Nome do Pai</label>
              <input
                  maxlength="60"
                  [readonly]="isNomePaiClienteTexto"
                  type="text"
                  class="form-control"
                  id="user-father-name"
                  placeholder="Digite o nome completo"
                  uppercase
                  [charOnly]="true"
                  maxlength="60"
                  name="nomePaiCliente"
                  [(ngModel)]="cliente.nomePai"
                  appShowErrorMessages
                  requiredMessage="Nome do Pai do Cliente é obrigatório"
                  [required]="!isNomePaiClienteTexto" />

              <div class="marginT10 check-mod" (click)="onClickNomePaiCliente()">
                  <label for="user-father-name">
                      <input maxlength="60" type="checkbox" id="user-father-name" name="ufn" value="0" [(ngModel)]="isNomePaiClienteTexto" />
                      <span class="radio-label">Sem pai no registro</span>
                  </label>
              </div>
          </div>
        </div>

        <div class="form-group">
            <span class="icon citizenship"></span>
            <div class="inputs">
                <label for="user-citizenship">Nacionalidade</label>
                <select *ngIf="!isLoadingNacionalidadeCliente"
                    id="user-citizenship"
                    class="form-control"
                    name="nacionalidadeCliente"
                    [(ngModel)]="cliente.nacionalidade.id"
                    (change)="onChangeNacionalidade($event.target.value)"
                    required
                    autocomplete="off"
                    [attr.autocomplete]="false">
                    <option value="undefined" selected hidden>Selecione...</option>
                    <option *ngFor="let nc of listaNacionalidadeCliente" value="{{ nc.id }}">{{ nc.descricao }}</option>
                </select>
                <span *ngIf="isLoadingNacionalidadeCliente">
                    <em class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></em> Carregando...</span>
            </div>
        </div>

        <div class="form-group" *ngIf="cliente.nacionalidade.id == 1">
          <span class="icon"></span>
          <div class="inputs">
              <label for="uf-nat-cli">Estado</label>
              <select id="uf-nat-cli"
                class="form-control"
                name="naturalUfCliente"
                (change)="onChangeNaturalUfCliente()"
                [(ngModel)]="cliente.naturalDeUf"
                required
                autocomplete="off"
                [attr.autocomplete]="false"
                appShowErrorMessages
                requiredMessage="Estado de Origem do Cliente é obrigatório">
                  <option value="undefined" selected hidden>Selecione...</option>
                  <option value="AC">AC - Acre</option>
                  <option value="AL">AL - Alagoas</option>
                  <option value="AP">AP - Amapá</option>
                  <option value="AM">AM - Amazonas</option>
                  <option value="BA">BA - Bahia</option>
                  <option value="CE">CE - Ceará</option>
                  <option value="DF">DF - Distrito Federal</option>
                  <option value="ES">ES - Espírito Santo</option>
                  <option value="GO">GO - Goiás</option>
                  <option value="MA">MA - Maranhão</option>
                  <option value="MT">MT - Mato Grosso</option>
                  <option value="MS">MS - Mato Grosso do Sul</option>
                  <option value="MG">MG - Minas Gerais</option>
                  <option value="PA">PA - Pará</option>
                  <option value="PB">PB - Paraíba</option>
                  <option value="PR">PR - Paraná</option>
                  <option value="PE">PE - Pernambuco</option>
                  <option value="PI">PI - Piauí</option>
                  <option value="RJ">RJ - Rio de Janeiro</option>
                  <option value="RN">RN - Rio Grande do Norte</option>
                  <option value="RS">RS - Rio Grande do Sul</option>
                  <option value="RO">RO - Rondônia</option>
                  <option value="RR">RR - Roraima</option>
                  <option value="SC">SC - Santa Catarina</option>
                  <option value="SP">SP - São Paulo</option>
                  <option value="SE">SE - Sergipe</option>
                  <option value="TO">TO - Tocantins</option>
              </select>

          </div>
        </div>

        <div class="form-group" *ngIf="cliente.nacionalidade.id == 1">
          <span class="icon"></span>
          <div class="inputs">
              <label for="user-city-cli">Cidade</label>
              <select *ngIf="!isLoadingNaturalCidadeCliente" autocomplete="off" [attr.autocomplete]="false" id="user-city-cli" class="form-control" [disabled]="!cliente.naturalDeUf" name="naturalCidadeCliente"
                  [(ngModel)]="cliente.naturalDe" required appShowErrorMessages requiredMessage="Cidade de Origem do Cliente é obrigatório">
                  <option value="undefined" selected hidden>Selecione...</option>
                  <option *ngFor="let ncid of listaNaturalCidadeCliente" value="{{ ncid.nomeCidade }}">{{ ncid.nomeCidade }}</option>
              </select>

              <span *ngIf="isLoadingNaturalCidadeCliente">
                  <em class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></em> Carregando...
              </span>
          </div>
        </div>

        <div class="form-group">
          <span class="icon patrimony"></span>
          <div class="inputs">
              <label for="user-patrimony">Valor total do Patrimônio</label>
              <input type="text"
                    class="form-control"
                    id="user-patrimony"
                    placeholder="Digite apenas números"
                    mask-money
                    appOnlyMoney
                    [prefix]="'R$'"
                    maxlength="17"
                    appShowErrorMessages
                    required
                    requiredMessage="Valor do patrimônio é obrigatório"
                    name="valorPatrimonioCliente"
                    [(ngModel)]="cliente.valorTotalPatrimonio"
              />
              <small>EX: veículo, imóvel, investimentos...
                  <br>
                  <strong>Importante</strong>: essa é uma informação exigida pelo Banco Central.</small>

          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-border-orange pull-left" (click)="fechar()">Fechar</button>
    <button class="btn btn-full-orange pull-right" (click)="salvar()" [disabled]="f.form.invalid">Salvar</button>
  </div>
</div>
